import { SparePartStatus } from '@savgroup-front-common/types';

import sparePartStatusMessages from '../helpers/i18n/messages/sparePartStatusMessages';

import { safeFormattedIntlString } from './safeFormattedIntlString';

const getSparePartStatusMessage = (
  status: SparePartStatus,
): ReturnType<typeof safeFormattedIntlString> => {
  let message;

  switch (status) {
    case SparePartStatus.ACTIVE: {
      message = sparePartStatusMessages.Active;
      break;
    }
    case SparePartStatus.OUTDATED: {
      message = sparePartStatusMessages.Outdated;
      break;
    }
    case SparePartStatus.DEPRECATED: {
      message = sparePartStatusMessages.Deprecated;
      break;
    }

    case SparePartStatus.NONE: {
      message = sparePartStatusMessages.None;
      break;
    }

    default:
      throw new Error(`Spare parts status ${status} does not exist`);
      break;
  }

  return safeFormattedIntlString(message);
};

export default getSparePartStatusMessage;
